export const IGNORED_FILES = new Set(['.DS_Store', 'Thumbs.db', '.gitkeep', 'desktop.ini']);

export async function readEntriesRecursively(
  entries: FileSystemEntry[]
): Promise<File[]> {
  const files: File[] = [];

  async function readEntry(entry: FileSystemEntry, path: string) {
    if (entry.isFile) {
      if (IGNORED_FILES.has(entry.name) || entry.name.startsWith('._')) return;

      const fileEntry = entry as FileSystemFileEntry;
      const file = await new Promise<File>((resolve, reject) => {
        fileEntry.file(resolve, reject);
      });
      const relativePath = path ? `${path}/${file.name}` : file.name;
      const fileWithPath = new File([file], relativePath, {
        type: file.type,
        lastModified: file.lastModified,
      });
      files.push(fileWithPath);
    } else if (entry.isDirectory) {
      const dirEntry = entry as FileSystemDirectoryEntry;
      const dirPath = path ? `${path}/${entry.name}` : entry.name;
      const reader = dirEntry.createReader();
      let batch: FileSystemEntry[];
      do {
        batch = await new Promise<FileSystemEntry[]>((resolve, reject) => {
          reader.readEntries(resolve, reject);
        });
        for (const child of batch) {
          await readEntry(child, dirPath);
        }
      } while (batch.length > 0);
    }
  }

  for (const entry of entries) {
    await readEntry(entry, '');
  }

  return files;
}

export async function getFilesFromDataTransfer(
  dataTransfer: DataTransfer
): Promise<File[]> {
  const items = dataTransfer.items;
  if (items?.length) {
    const entries: FileSystemEntry[] = [];
    for (let i = 0; i < items.length; i++) {
      const entry = items[i].webkitGetAsEntry?.();
      if (entry) entries.push(entry);
    }

    if (entries.length > 0) {
      return readEntriesRecursively(entries);
    }
  }

  // Fallback: plain files
  return Array.from(dataTransfer.files).filter(
    f => !IGNORED_FILES.has(f.name) && !f.name.startsWith('._')
  );
}
